import { atom } from 'recoil';

export const ConfirmAtom = atom({
  key: 'Confirm',
  default: null,
});
